import Navbar from '../Navbar';
import Sidebar from '../Sidebar.js';
import TicketNotifier from '../TicketNotifier';
import styles from './PageShell.module.css';

// Standard page wrapper: Navbar + Sidebar + a main-content area that gets
// the sidebar-offset margin. Replaces the ad hoc <Navbar/><Sidebar/><div
// className="main-content"> markup every page previously reimplemented
// (and sometimes got wrong, e.g. Settings.js not using it at all).
export default function PageShell({ children, contentClassName = '' }) {
  return (
    <div className={styles.shell}>
      <Navbar />
      <Sidebar />
      <TicketNotifier />
      <div className={`main-content ${contentClassName}`}>
        {children}
      </div>
    </div>
  );
}
